<template>
  <div v-if="showAdminToolbar" class="admin-menu no-print" :class="{ 'is-IE': isIE11, 'edit-mode' : edit && fromStartButtonTemplate && !isMobile}">
    <div class="admin-container">
      <span class="admin-transparent">
        <div class="subtitle is-7 has-text-grey is-marginless is-hidden-mobile">ADMIN</div>
        <div v-if="isAdmin" class="toggle-hide"><a tabindex="0" @keypress.enter.space="hideProject" @click="hideProject"><strong>{{hiddenTitle}} </strong><span class="icon"><i :class="hiddenIcon" :aria="hiddenTitle"></i></span></a></div>
        <div class="project-created"><strong><span class="is-hidden-mobile">Project</span> Creation Date</strong> <div>{{(project && project.created) && project.created.slice(0,10)}}</div></div>
        <div class="project-id"><strong><span class="is-hidden-mobile">Project</span> ID</strong> <div>{{project.id}}</div></div>
        <div class="project-id"><strong><span class="is-hidden-mobile">Template</span> ID</strong> <div>{{project.sourceProjectID}}</div></div>
        <div v-if="isSnapshot" class="project-id"><strong>Snapshot</strong> <div>✅</div></div>
        <div v-if="adminToolbarBecomeUser" class="become-user is-hidden-mobile"><a @click="becomeUser"><strong>Become <span class="is-hidden-mobile">User</span></strong><span class="icon"><i class="fal fa-user-secret" aria="Become User"></i></span></a></div>
        <span v-if="$isStories && project.article">
          <div class="project-id"><strong>Article ID</strong> <div>{{project.article.id}}</div></div>
          <div class="is-hidden-mobile"><a :href="project.article.url" target="_blank"><strong>AMP</strong></a></div>
          <div class="is-hidden-mobile"><a :href="project.article.mainURL" target="_blank"><strong>EngCom</strong></a></div>
        </span>
      </span>
      <div class="is-hidden-mobile">
        <div class="subtitle is-7 has-text-grey is-marginless is-hidden-mobile">CATEGORIES <span class="icon cursor-pointer" tabindex="0" @keypress.enter.space="toggleEditCategories" @click="toggleEditCategories"><i class="fal" :class="{'fa-pencil-alt': !editCategories, 'fa-times': editCategories}"></i></span></div>
        <template v-if="!editCategories">
          <div v-for="category in project.categories" :key="category.id">{{category.name}}</div>
        </template>
        <template v-if="editCategories">
          <category-selector v-model="chosenCategories" :includeSubCategories="true" :isAdminMenu="true" ></category-selector>
          <button class="button is-primary is-outlined is-small" @click="saveCategories">Save</button>
          <button class="button is-info is-outlined is-small" :class="{'is-loading': isSuggesting}" @click="suggestCategories">Suggest</button>
          <div v-if="suggestedCategories" class="suggestions">
            <div class="subtitle is-7 has-text-grey is-marginless is-hidden-mobile">SUGGESTIONS</div>
            <span v-for="suggestion in suggestedCategories" :key="suggestion.category.id" class="tag cursor-pointer" :class="suggestion.category.slug" @click="addSuggestion(suggestion.category)" :data-balloon="`Confidence: ${Math.round(suggestion.percentScore * 100)}%`" data-balloon-pos="right">{{suggestion.category.name}}</span>
            <span v-if="suggestedCategories.length === 0">None</span>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import userAgent from '@/libs/user-agent'
import breakpoints from '@/libs/breakpoints'
import auth from '@/mixins/auth'
import componentState from '@/mixins/component-state'
import state from '../state'
import CategorySelector from '@/components/Inputs/CategorySelector'

export default {
  components: {
    CategorySelector
  },
  mixins: [auth, componentState],
  props: ['isPrivate', 'projectRole', 'edit', 'isSnapshot', 'showAdminToolbar', 'adminToolbarBecomeUser'],
  data: function () {
    return {
      editCategories: false,
      chosenCategories: [],
      isSuggesting: false,
      suggestedCategories: null
    }
  },
  computed: {
    project: function () {
      return this._get(state.project.id) ? this.$store.getters.project(this._get(state.project.id)) || {} : {}
    },
    isHidden: function () {
      return this.project.isHidden
    },
    hiddenTitle: function () {
      return this.isHidden ? 'Unhide' : 'Hide'
    },
    blueRibbonTitle: function () {
      return this.blueRibbon ? 'Don\'t Allow' : 'Allow'
    },
    hiddenIcon: function () {
      return this.isHidden ? 'fal fa-eye' : 'fal fa-eye-slash'
    },
    isIE11: function () {
      return userAgent.isIE11()
    },
    blueRibbon: function () {
      return this.project.blueRibbon
    },
    fromStartButtonTemplate: function () {
      return this.$route.params.startButton || this.fromTemplate
    },
    isMobile: function () {
      return breakpoints.isMobile()
    }
  },
  methods: {
    hideProject: function () {
      const params = { id: this.project.id, isHidden: !this.isHidden }
      this.$store.dispatch('updateProjectHidden', params).then(() => {
      }, (error) => {
        this.clicked = false
        this.error = error.message
      })
    },
    hideBlueRibbon: function () {
      const params = { id: this.project.id, BlueRibbon: !this.blueRibbon }
      this.$store.dispatch('updateBlueRibbon', params).then(() => {
      }, (error) => {
        this.clicked = false
        this.error = error.message
      })
    },
    becomeUser: function () {
      if (this.project && this.project.user) {
        this.$router.push({ name: 'admin', params: { username: this.project.user.userName, redirect: this.$route.path, component: 'UsersBecome' } })
      }
    },
    toggleEditCategories: function () {
      if (this.project.categories) {
        this.chosenCategories = this.project.categories.slice()
      }
      this.editCategories = !this.editCategories
      this.suggestedCategories = null
    },
    saveCategories: function () {
      const categoryIDs = this.chosenCategories.map((category) => category.id)
      this.$store.dispatch('updateProjectCategories', { id: this.project.id, categories: categoryIDs }).then((response) => {
        this.toggleEditCategories()
      })
    },
    suggestCategories: function (event) {
      event.target.blur()
      this.isSuggesting = true
      this.$store.dispatch('suggestProjectCategories', this.project.id).then((suggestions) => {
        this.suggestedCategories = suggestions
        this.isSuggesting = false
      }, () => {
        this.isSuggesting = false
      })
    },
    addSuggestion: function (category) {
      if (this.chosenCategories.filter((c) => c.id === category.id).length === 0) {
        this.chosenCategories.push(category)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';
.edit-mode {
  margin-top: 60px !important;
}
.admin-menu {
  font-size: 0.8rem;
  position: relative;
  width: 100%;
  left: 0;
  top: 0;
  margin-top: .5rem;
  .admin-container {
     background-color: var(--background-secondary);
    color: $grey;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.25rem;
    & > div {
      padding: 0 .5rem;
    }
    @include mobile {
      justify-content: space-between;
      padding: 0 0.25rem;
    }
    .admin-transparent {
      width: 80%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      opacity: 0.5;
    }
  }
  .project-id {
    display: inline-block;
    & > div {
      display: inline;
    }
  }
}
.toggle-hide a, .become-user a{
  color: $dark;
}
.is-IE {
  left: calc(100vw/2 - 400px - 150px - 16px);
}
.suggestions {
  .subtitle {
    padding: 0.3rem 0;
  }
  .tag {
    margin-right: 0.3rem;
    font-size: 0.6rem;
    color: white;
    border-radius: 0;
    margin-bottom: 0.3rem;
  }
}

</style>
